/**
 * Resolve blog article Page slugs via Contentful linkedFrom (CF-050 fallback when Blog.url is empty).
 */

import gql from 'graphql-tag';

export const getBlogPageSlugsByBlogIds = gql`
  query GetBlogPageSlugsByBlogIds(
    $locale: String!
    $blogIds: [String]!
    $preview: Boolean
  ) {
    blogCollection(
      locale: $locale
      preview: $preview
      limit: 20
      where: {sys: {id_in: $blogIds}}
    ) {
      items {
        sys {
          id
        }
        linkedFrom {
          pageCollection(limit: 1) {
            items {
              slug
            }
          }
        }
      }
    }
  }
`;
